import React, { useState } from "react";
import { BtnPrimary, BtnAlternative } from "../../share/buttons/Btn";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import TableSort from "../../share/Table/TableSort/TableSort";
import Card from "../../share/cards/Card";
import { Modal } from "../../share/modal/Modal";
import PriorityNewGroup from "./PriorityNewGroup";
import EmptyPic from "../../../Assets/Image/png/full.png";
import useFetch from "../../../Hooks/useFetch";

function IdeaInPriority({ idPriority }) {
    const [ar, setAr] = useState();
    const [priorityList, setPriorityList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [show, setShow] = useState(false);
    const [all, setAll] = useState(false);

    const getPriorityService = useFetch({
        method: "GET",
        url: `BootCampIdeasPriorityService/11/usersIdeasPriority`,
        noHeader: false,
        trigger: true,
        setter: (data) => {
            setPriorityList(data.results);
        },
    });

    const handleSelectUser = (selectedUserID) => {
        const listUser = [...nameList];
        const isHasUser = listUser.includes(selectedUserID);
        if (isHasUser) {
            setNameList((prev) =>
                prev.filter((userID) => userID !== selectedUserID)
            );
        } else {
            setNameList((prev) => [...prev, selectedUserID]);
        }
    };

    const { items, requestSort, sortConfig } = TableSort(priorityList);
    return (
        <div className="px-10">
            <div className=" flex SupportTicket__header justify-between items-center mt-[5rem]">
                <h3 className=" text-[#77498F] text-[1.6rem] font-bold">
                    اطلاعات ایده های بوت کمپ
                </h3>
                <BtnPrimary
                    text="ثبت گروه"
                    className={`px-16 py-7 ${
                        !nameList.length
                            ? "btn-disabled cursor-not-allowed"
                            : ""
                    } `}
                    isDisabled={!nameList.length}
                    onClick={() => setShow(true)}
                />
            </div>
            {all ? (
                <Card>
                    <div className=" pt-20 pb-24 px-[20rem] flex flex-col justify-center items-center">
                        <h3 className="font-bold text-[1.6rem] text-purple-dark mb-20">
                            تبریک !!
                        </h3>
                        <div className="mb-4">
                            <img src={EmptyPic} alt="EmptyPic" />
                        </div>
                        <p className=" text-[1.8rem] mb-14">
                            تمامی افراد به تیم ها اضافه شدند!
                        </p>
                        <BtnAlternative
                            text="نمایش لیست تیم ها"
                            className=" py-11 px-[7.8rem]"
                            //   onClick={() => props.show(true)}
                        />
                    </div>
                </Card>
            ) : (
                <>
                    <p className=" mt-[1.3rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem]">
                        با انتخاب افراد بر اساس اولویت ها و سپس فشرد دکمه ثبت
                        گروه، میتوانید تیم های خود را تشکیل دهید.
                    </p>
                    <Card className=" grid grid-cols-5 px-[3rem] py-[1.5rem] gap-[4rem] justify-items-center justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-header mt-[1rem]">
                        {header.map((item, id) =>
                            id === 0 ? (
                                <div
                                    key={item.title}
                                    className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] justify-self-start"
                                >
                                    {item.title}
                                </div>
                            ) : (
                                <div
                                    className={` flex flex-row items-center cursor-pointer text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]`}
                                    onClick={() => {
                                        setAr(id);
                                        requestSort(
                                            id === 1
                                                ? "priprity1"
                                                : id === 2
                                                ? "priprity2"
                                                : id === 3
                                                ? "priprity3"
                                                : "priprity4"
                                        );
                                    }}
                                    key={id}
                                >
                                    {item.title}
                                    {ar === id ? (
                                        sortConfig?.direction !==
                                        "ascending" ? (
                                            <AiOutlineDown className=" mr-[0.3rem]" />
                                        ) : (
                                            <AiOutlineUp className=" mr-[0.3rem]" />
                                        )
                                    ) : (
                                        <AiOutlineDown className=" mr-[0.3rem]" />
                                    )}
                                </div>
                            )
                        )}
                    </Card>
                    {items.map((item, id) => (
                        <Card
                            key={id}
                            className=" grid grid-cols-5 px-[3rem] py-[1.5rem] gap-[4rem] justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-body  my-4"
                        >
                            <div className=" flex flex-row items-center justify-start">
                                <input
                                    type="checkbox"
                                    name={item?.user}
                                    value={item?.id}
                                    className=" PriceForm radio-lg ml-[1.4rem]"
                                    id={item?.user}
                                    onClick={() => {
                                        handleSelectUser(item?.id);
                                    }}
                                />
                                {item?.user}
                            </div>
                            <div>{item?.user_idea_priority_one}</div>
                            <div>{item?.user_idea_priority_two}</div>
                            <div>{item?.user_idea_priority_three}</div>
                            <div>{item?.user_idea_priority_four}</div>
                        </Card>
                    ))}
                </>
            )}
            <Modal show={show}>
                <PriorityNewGroup
                    close={setShow}
                    name={nameList}
                    list={priorityList}
                    all={setAll}
                    getPriorityService={getPriorityService}
                />
            </Modal>
        </div>
    );
}

export default IdeaInPriority;

const header = [
    { title: "نام کاربر" },
    { title: "اولویت اول" },
    { title: "اولویت دوم" },
    { title: "اولویت سوم" },
    { title: "اولویت چهارم" },
];
// const list = [
// 	{
// 		id: 1,
// 		name: 'علی رجبی',
// 		priprity1: 'ایده 1',
// 		priprity2: 'ایده 1',
// 		priprity3: ' ایده 1',
// 		priprity4: 'ایده 1',
// 	},
// 	{
// 		id: 2,
// 		name: 'سارا صیادی',
// 		priprity1: 'ایده 2',
// 		priprity2: 'ایده 2',
// 		priprity3: ' ایده 2',
// 		priprity4: 'ایده 2',
// 	},
// 	{
// 		id: 3,
// 		name: 'هنگامه مهاجر',
// 		priprity1: 'ایده 3',
// 		priprity2: 'ایده3',
// 		priprity3: ' ایده 3',
// 		priprity4: 'ایده 3',
// 	},
// ];
